/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { InjectionToken } from '@angular/core';
export var NB_THEME_OPTIONS = new InjectionToken('Nebular Theme Options');
export var NB_MEDIA_BREAKPOINTS = new InjectionToken('Nebular Media Breakpoints');
export var NB_BUILT_IN_JS_THEMES = new InjectionToken('Nebular Built-in JS Themes');
export var NB_JS_THEMES = new InjectionToken('Nebular JS Themes');
/**
 * We're providing browser apis with tokens to improve testing capabilities.
 * */
export var NB_WINDOW = new InjectionToken('Window');
export var NB_DOCUMENT = new InjectionToken('Document');
//# sourceMappingURL=theme.options.js.map